import { CancelItemRequestState } from './cancelItemRequest.types'

const initialState: CancelItemRequestState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
